import { alpha, height, maxHeight, width } from "@mui/system";

const styles = (theme) => ({
  paperContainer: {
    margin: "10px 0",
    p: 2,
    borderRadius: "16px",
  },
  title: { fontWeight: "bold", fontSize: "20px" },
  containerCards: {
    height: "300px",
    overflowY: "auto",
    paddingRight: "8px",
  },
  paperCard: {
    p: 2,
    width: "100%",

    borderRadius: 3,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: theme.palette.background.wallpaper,
  },
  boxInfo: {
    width: "100%",
    minHeight: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mt: 4,
  },
  boxHeader: {
    display: "flex",
    gap: 2,
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: { xs: "flex-start", sm: "flex-end" },
    width: { xs: "100%", md: "auto" },
  },
  chip: { fontSize: "12px", fontWeight: "bold", textTransform: "capitalize" },
  boxChip: { display: "flex", justifyContent: "flex-start" },
  description: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    minHeight: "40px",
    mb: 2,
  },
  containerActions: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifyContent: "flex-end",
    p: 2,
  },
  containerModal: {
    position: "absolute",
    borderRadius: "16px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: " 90%",
    maxWidth: "1000px",
    height: "700px",
    maxHeight: "90vh",
    boxShadow: 24,
    bgcolor: "background.paper",
    overflow: "hidden",
    p: 2,
    minHeight: "400px",
    display: "flex",
    flexDirection: "column",
  },
  boxIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 40,
    height: 40,
    borderRadius: 2,
    color: "primary.main",
  },
  containerHeader: {
    display: "flex",
    // No mobile (xs) empilha, no desktop (md) fica lado a lado
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "flex-start", md: "center" },
    gap: 2,
    width: "100%",
    p: 1,
  },
});
export default styles;
